export const FILE_TYPES = {
  digitalPrescription: 1,
  intraoralScans: 2,
  clinicalPhotos: 3,
  cbctImages: 4,
  completedSurgicalPlan: 8,
};
